import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import 'react-quill/dist/quill.snow.css';
import './index.css';
import './texts.css';
import './antd.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { persistor, store } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import 'react-phone-input-2/lib/style.css';

const rootElement = document.getElementById('root');

const app = (
	<HelmetProvider>
		<GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
						<App />
						<Toaster
							position='top-center'
							reverseOrder={false}
							toastOptions={{
								duration: 5000,
							}}
						/>
				</PersistGate>
			</Provider>
		</GoogleReCaptchaProvider>
	</HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}

reportWebVitals();
